import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Dashboard2Layout } from "components/dashboard2/Dashboard2Layout"
import UserService from "services/user.service"
import { EvoEmptyState, EvoPageHeader } from "components/evo"
import { Loader } from "common/Loader"

const service = new UserService()

export const Stats = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    setLoading(true)
    service
      .getOffices()
      .then((resp) => {
        setData(resp.data.data);
        setLoading(false)
      })
      .catch((error) => console.log(error))
  }, [])

  return (
    <Dashboard2Layout>
      <div className="px-5 pt-5">
        <EvoPageHeader
          title="Dashboard offices"
          subtitle="Legacy dashboard — pick an office to view detailed stats."
        />
      </div>
      <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-3 md:gap-6">
        {loading ? (
          <div className="col-span-full flex justify-center py-16">
            <Loader />
          </div>
        ) : data?.length === 0 ? (
          <div className="col-span-full">
            <EvoEmptyState />
          </div>
        ) : (
          data.map((item, index) => (
            <Link
              key={index}
              to={`/dashboard2/stats/${item}`}
              className="flex w-full cursor-pointer items-center gap-4 rounded-xl border border-evo-border bg-[var(--evo-surface)] p-4 shadow-[var(--evo-shadow-sm)] transition hover:bg-[var(--evo-hover)]"
            >
              <div className="h-9 w-9 shrink-0 rounded-full bg-primary/20" />
              <p className="w-full text-center text-xl font-semibold text-[var(--evo-text)] sm:text-2xl">
                {item}
              </p>
            </Link>
          ))
        )}
      </div>
    </Dashboard2Layout>
  )
}
